var _ellipse, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6, _circle4, _circle5, _circle6, _circle7, _circle8, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGutensliderStartImage = function SvgGutensliderStartImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1025.5,
    height: 720.713
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 521.811,
    cy: 689.117,
    rx: 503.689,
    ry: 31.597,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.691 658.139c11.55 21.42 36.063 30.615 36.063 30.615s5.787-25.534-5.763-46.954-36.063-30.614-36.063-30.614-5.787 25.533 5.763 46.953Z",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.63 651.092c20.852 12.545 28.883 37.464 28.883 37.464s-25.777 4.579-46.63-7.967S0 643.125 0 643.125s25.777-4.579 46.63 7.967Z",
    fill: "#9d50bb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M101.717 88.343h825.318V114.6H101.717z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d50bb",
    d: "M927.035 681.247H101.717V504.122l91.114-78.33 734.204-55.67v311.125z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 123.803,
    cy: 101.085,
    r: 6.795,
    fill: "#9d50bb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.888,
    cy: 101.085,
    r: 6.795,
    fill: "#9d50bb"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.973,
    cy: 101.085,
    r: 6.795,
    fill: "#9d50bb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m101.717 503.715 825.318-134.449V114.6H101.717v389.115z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M834.64 560.28q-33.421-5.662-64.282-9.725l8.134-15.77c-2.743-.952-14.792 8.078-14.792 8.078l10.673-45.774c-13.793 1.663-20.806 48.402-20.806 48.402l-15.41-15.802 7.46 17.766c-62.968-7.416-117.35-10.165-163.09-10.264l6.961-13.497c-2.742-.953-14.792 8.078-14.792 8.078l10.674-45.775c-13.794 1.664-20.807 48.402-20.807 48.402l-15.41-15.802 7.902 18.817a916.12 916.12 0 0 0-93.754 6.368c7.041-21.026 30.96-41.023 30.96-41.023-18.267 5.433-27.848 14.537-32.855 23.024a368.671 368.671 0 0 1 21.309-127.38s-37.757 82.161-32.939 137.312l.576 9.793c-32.009 4.583-48.102 9.352-48.102 9.352ZM161.279 263.984h230.47v9.293h-230.47zM161.279 284.429h230.47v9.293h-230.47zM161.279 304.874h78.063v9.293h-78.063z",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 488.085,
    cy: 663.612,
    r: 9.066,
    fill: "#f2f2f2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 514.376,
    cy: 664.519,
    r: 9.066,
    fill: "#f2f2f2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 540.667,
    cy: 665.425,
    r: 9.066,
    fill: "#f2f2f2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 514.459,
    cy: 664.519,
    r: 7.253,
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 773.315,
    cy: 133.243,
    r: 83.979,
    fill: "#ff6584"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M831.77 234.403c16.533 112.831-44.772 162.052-127.508 174.175q-2.883.423-5.748.777-5.77.718-11.46 1.144c-75.447 5.654-139.536-27.258-154.912-132.19C516.23 169.715 634.937 12.336 643.862.678c.008-.002.008-.002.016-.012.34-.444.513-.667.513-.667S815.237 121.58 831.77 234.403Z",
    fill: "#9d50bb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m696.28 392.118 43.574-84.586-42.48 93.01 1.14 8.813q-5.77.718-11.46 1.144l-10.637-113.743-.174-.867.077-.18-1.002-10.748-67.55-77.104 66.545 69.089.469 2.242-8.037-85.937-60.04-81.106 58.423 66.033L643.86.678l-.068-.59.085.579 19.66 139.555 38.822-62.156-37.264 74.194 9.949 76.546 33.094-79.707-31.624 90.96 5.533 42.563 48.663-111.33-46.74 126.18Z",
    fill: "#3f3d56"
  })));
};

export { SvgGutensliderStartImage as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiaW1hZ2VzL2d1dGVuc2xpZGVyX3N0YXJ0X2ltYWdlLnN2ZyI7";